import React, { useEffect, useState } from "react";
import { api } from "../admin/api";

// Public hook: fetches saved site_settings (contact + models). Falls back to null on error.
export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/content/settings");
        if (mounted) setSettings(data || {});
      } catch {
        if (mounted) setSettings({});
      } finally {
        if (mounted) setLoaded(true);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return { settings: settings || {}, loaded };
};
